import {
  INVITATION_STATUSES as SharedINVITATION_STATUSES
} from "shared/dist/types/Invitation";

import type { Invitation as SharedInvitation, InvitationStatus } from "shared/dist/types/Invitation";

export { InvitationStatus };
export const INVITATION_STATUSES = SharedINVITATION_STATUSES;

export default interface Invitation extends SharedInvitation {}
